angular.module('impactx.MenuDirectives').controller('UserinfoDialogCtrl', ['$scope', '$mdDialog', 'dataGen', '$context', '$redirect', '$securityManager', 'LoginService', UserinfoDialogCtrl]);

function UserinfoDialogCtrl($scope, $mdDialog, dataGen, $context, $redirect, $securityManager, LoginService)
{
    $scope.customerServiceUserShown = $context.customerServiceUser.value;

    $scope.userImageUrl = $context.userImageUrl;
    $context.refreshUser($scope, dataGen, $context);
    $scope.hide = function ()
    {
        $mdDialog.hide();
    };
    $scope.redirectToProfile = function()
    {
        $redirect.redirectTo(null, "/userprofile");
        $mdDialog.hide();
    };
    $scope.reLogin = function(user)
    {
        $mdDialog.hide();
        if (!user.isLoggedIn && !user.disabled)
        {
            var dataObj = {
                delegateUserId: user.userId
            };
            dataGen.postAsForm($scope, dataObj, "/delegation/delegatelogin").then(function ()
            {
                $securityManager.invalidateProcesses();
                LoginService.refreshUI(true);
            });
        }
    };
    $scope.redirectToAllDelegations = function()
    {
        $mdDialog.hide();
        $redirect.redirectTo(null, "/delegationlogin");
    }
}